<script>
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'editCustomerSale',
  props: ['stockOutRow'],
  data() {
    return {
      loading: false,
      fetch_customer: false,
      fetch_sale: false,
      errors: new Errors(),
      model: {
        stock_out_id: undefined,
        customer_id: undefined,
        seller_id: undefined
      }
    }
  },
  computed: {
    ...mapState('saleInvoiceStore', ['customers', 'saleEmployees']),
    customerList() {
      return this.customers.map(el => ({
        value: el.customer_id,
        label: el.customer_name,
        credit_amount: el.credit_amount,
        contact_number: el.contact_number,
        credit_day: el.credit_day,
        employee_id: el.employee_id
      }))
    },
    employeeList() {
      return this.saleEmployees.map(el => ({
        value: el.employee_id,
        label: el.employee_name_en
      }))
    }
  },
  async mounted() {
    await this.fetchResource()
    this.model.stock_out_id = this.stockOutRow.stock_out_id
    this.model.customer_id = this.stockOutRow.customer_id
    this.model.seller_id = this.stockOutRow.seller_id
  },
  methods: {
    ...mapActions('saleInvoiceStore', [
      'onGetCustomer',
      'onGetSale',
      'onUpdateSaleCustomer'
    ]),
    handleCustomerSearch: debounce(function(search_customer) {
      this.fetch_customer = true
      this.onGetCustomer({
        params: {
          search_customer
        }
      }).finally(() => (this.fetch_customer = false))
    }, 500),
    handleSaleSearch: debounce(function(value) {
      this.fetch_sale = true
      this.onGetSale(value).finally(() => (this.fetch_sale = false))
    }, 500),
    async fetchResource() {
      this.loading = true
      await this.onGetCustomer({
        params: {
          search_customer: this.stockOutRow.customer_name
        }
      })
      await this.onGetSale(this.stockOutRow.sale_name)
      this.loading = false
    },
    onUpdate() {
      this.loading = true
      this.onUpdateSaleCustomer(this.model)
        .then(response => {
          this.$toasted.success(response.data.message)
          this.$emit('cancel')
        })
        .catch(({ response }) => {
          this.$toasted.error(response.data.message)
          this.errors = new Errors(response.data.errors)
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>

<template>
  <ts-loading-banner :loading="loading">
    <div class="ts-space-y-3">
      <div class="row">
        <div class="col-md-12">
          <label class="required ts-mb-0">{{
            $t('saleInvoice.customer')
          }}</label>
          <a-select
            show-search
            v-model="model.customer_id"
            style="width: 100%"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            :loading="fetch_customer"
            @search="handleCustomerSearch"
            filterable
          >
            <a-select-option
              v-for="c in customerList"
              :key="c.value"
              :value="c.value"
              :opt="c"
            >
              {{ c.label + (c.contact_number ? ' ' + c.contact_number : '') }}
            </a-select-option>
          </a-select>
          <div class="validate" v-if="errors.has('customer_id')">
            {{ errors.first('customer_id') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required ts-mb-0">{{ $t('saleInvoice.saler') }}</label>
          <a-select
            show-search
            style="width: 100%"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            :loading="fetch_sale"
            @search="handleSaleSearch"
            v-model="model.seller_id"
            :options="employeeList"
            class="ts-w-full"
          ></a-select>
          <div class="validate" v-if="errors.has('seller_id')">
            {{ errors.first('seller_id') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2 ts-mt-3">
          <ts-button @click.prevent="$emit('cancel')"
            >{{ $t('cancel') }}
          </ts-button>
          <ts-button @click.prevent="onUpdate" color="primary">{{
            $t('update')
          }}</ts-button>
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>
